import { siteSchema } from '@sophocles/entities/Site';
import { Record } from 'immutable';
import { schema } from 'normalizr';

export const MonthlySolarReport = new Record({
  id: undefined,
  consumed: undefined,
  generated: undefined,
  corrected: undefined,
  month_end_date: undefined,
  site: undefined,
});

export const monthlySolarReportSchema = new schema.Entity('monthlySolarReports', { site: siteSchema });
